const moneyService = ($rootScope, $window) => {
    const getCurrencyDetails = (currencyCode = null) => {
        if (currencyCode) {
            return determineCurrency(currencyCode);
        }

        if ($window.config && $window.config.currency) {
            return determineCurrency($window.config.currency);
        }

        return determineCurrency($rootScope.currentProperty.currency_code);
    };

    const determineCurrency = (currencyCode) => {
        switch (currencyCode) {
            case 'EUR':
                return {
                    symbol: '€',
                    magnitude: 100,
                    decimals: 2
                };
            case 'JPY':
                return {
                    symbol: '¥',
                    magnitude: 1,
                    decimals: 0
                };
            case 'USD':
                return {
                    symbol: '$',
                    magnitude: 100,
                    decimals: 2
                };
            default:
            case 'GBP':
                return {
                    symbol: '£',
                    magnitude: 100,
                    decimals: 2
                };
        }
    };

    const reduce = (amount, decorate = false) => {
        const currency = getCurrencyDetails(decorate);
        let decoration = '';
        if (decorate) {
            decoration = currency.symbol;
        }
        return `${decoration}${(amount / currency.magnitude).toFixed(currency.decimals)}`;
    };

    const magnify = (amount) => {
        const currency = getCurrencyDetails();
        return amount * currency.magnitude;
    };

    return {
        getCurrencyDetails,
        reduce,
        magnify
    };
};

moneyService.$inject = ['$rootScope', '$window'];

export default moneyService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/services/money.service.js